if (!customElements.get("product-form")) {
	customElements.define(
		"product-form",
		class ProductForm extends HTMLElement {
			constructor() {
				super();

				this.form = this.querySelector("form");
				this.form.querySelector("[name=id]").disabled = false;
				this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
				this.cart =
					document.querySelector("cart-notification") ||
					document.querySelector("cart-drawer");
				this.submitButton = this.querySelector('[type="submit"]');
				if (document.querySelector("cart-drawer"))
					this.submitButton.setAttribute("aria-haspopup", "dialog");

				this.hideErrors = this.dataset.hideErrors === "true";
			}

			async onSubmitHandler(evt) {
				evt.preventDefault();
				if (this.submitButton.getAttribute("aria-disabled") === "true") return;

				this.handleErrorMessage();

				this.submitButton.setAttribute("aria-disabled", true);
				this.submitButton.classList.add("loading");
				//this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

				const config = fetchConfig("javascript");
				config.headers["X-Requested-With"] = "XMLHttpRequest";
				delete config.headers["Content-Type"];

				const formData = new FormData(this.form);
				if (this.cart) {
					formData.append(
						"sections",
						this.cart.getSectionsToRender().map((section) => section.id)
					);
					formData.append("sections_url", window.location.pathname);
					this.cart.setActiveElement(document.activeElement);
				}
				config.body = formData;

				if (typeof isCustom == "boolean" && isCustom) {

					if (typeof customData.engravingSettings?.engravingList == "object" && customData.engravingState == 1) {
						  let tempEngravingList = customData.engravingSettings.engravingList;
						  let errorInfo = null;
						  for (let i = 0; i < tempEngravingList.length; i ++) {
							  if (typeof productOptions[tempEngravingList[i].title] == "undefined" || !productOptions[tempEngravingList[i].title]) {
								  errorInfo = "Please input " + tempEngravingList[i].title
								  break;
							  }
						  }
						  if (errorInfo != null) {
							  this.submitButton.classList.remove("loading");
							  this.submitButton.removeAttribute("aria-disabled");
							  alert(errorInfo);
							  return;
						  }
					  }
  
					  if (typeof customData.stoneSettings?.stoneList == "object" && customData.stoneState == 1) {
						  let tempEngravingList = customData.stoneSettings.stoneList;
						  let errorInfo = null;
						  for (let i = 0; i < tempEngravingList.length; i ++) {
							  if (typeof productOptions[tempEngravingList[i].title] == "undefined" || !productOptions[tempEngravingList[i].title]) {
								  errorInfo = "Please select " + tempEngravingList[i].title
								  break;
							  }
						  }
						  if (errorInfo != null) {
							  this.submitButton.classList.remove("loading");
							  this.submitButton.removeAttribute("aria-disabled");
							  alert(errorInfo);
							  return;
						  }
					  }
					
					  Object.keys(productOptions).map(v => {
						  formData.append(`properties[${v}]`, productOptions[v]);
					  })
					if (customData.previewSettings.previewType == 3) {
                      console.log("z1", new Date());
                          let zele = document.querySelector(".cc-popup-preview");
						  await html2canvas(zele, {
							  allowTaint: true,
                              logging: false,
							  useCORS: true, // 如果截图的内容里有图片,可能会有跨域的情况,加上这个参数,解决文件跨域问题
                            ignoreElements: e => {
                                if (
                                  e.contains(zele) ||
                                  zele.contains(e) ||
                                  e.tagName === 'STYLE' ||
                                  e.tagName === 'LINK' ||
                                  e.getAttribute('data-html2canvas') != null // header里面的样式不能筛掉
                                ) {
                                  return false;
                                }
                                
                                return true;
                              }
							}).then(canvas => {
                            console.log("z2", new Date());
							  $.ajax({
								  url: apiLink + "api/data/uploadDataUrl",
								  method: "post",
								  data: {content: canvas.toDataURL()},
								  dataType: "json",
								  async: false,
								  success: (res) => {
                                    console.log("z3", new Date());
									if (res.code == 1) {
									  formData.set(`properties[_Preview image]`, `${res.data.url}`);
									}
								  }
								});
						  });
					  }
				  }

				fetch(`${routes.cart_add_url}`, config)
					.then((response) => response.json())
					.then((response) => {
						if (response.status) {
							publish(PUB_SUB_EVENTS.cartError, {
								source: "product-form",
								productVariantId: formData.get("id"),
								errors: response.description,
								message: response.message,
							});
							this.handleErrorMessage(response.description);

							const soldOutMessage =
								this.submitButton.querySelector(".sold-out-message");
							if (!soldOutMessage) return;
							this.submitButton.setAttribute("aria-disabled", true);
							this.submitButton.querySelector("span").classList.add("hidden");
							soldOutMessage.classList.remove("hidden");
							this.error = true;
							return;
						} else if (!this.cart) {
							window.location = window.routes.cart_url;
							return;
						}

						if (!this.error)
							publish(PUB_SUB_EVENTS.cartUpdate, {
								source: "product-form",
								productVariantId: formData.get("id"),
							});
						this.error = false;
						const quickAddModal = this.closest("quick-add-modal");
						if (quickAddModal) {
							document.body.addEventListener(
								"modalClosed",
								() => {
									setTimeout(() => {
										this.cart.renderContents(response);
									});
								},
								{ once: true }
							);
							quickAddModal.hide(true);
						} else {
							this.cart.renderContents(response);
						}
					})
					.catch((e) => {
						console.error(e);
					})
					.finally(() => {
						this.submitButton.classList.remove("loading");
						if (this.cart && this.cart.classList.contains("is-empty"))
							this.cart.classList.remove("is-empty");
						if (!this.error) this.submitButton.removeAttribute("aria-disabled");
						//this.querySelector('.loading-overlay__spinner').classList.add('hidden');
					});
			}

			handleErrorMessage(errorMessage = false) {
				if (this.hideErrors) return;

				this.errorMessageWrapper =
					this.errorMessageWrapper ||
					this.querySelector(".product-form__error-message-wrapper");
				if (!this.errorMessageWrapper) return;
				this.errorMessage =
					this.errorMessage ||
					this.errorMessageWrapper.querySelector(
						".product-form__error-message"
					);

				this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

				if (errorMessage) {
					this.errorMessage.textContent = errorMessage;
				}
			}
		}
	);
}
